import { render, staticRenderFns } from "./ThreatCanvasLayout.vue?vue&type=template&id=736b8c6d&scoped=true"
import script from "./ThreatCanvasLayout.vue?vue&type=script&lang=js"
export * from "./ThreatCanvasLayout.vue?vue&type=script&lang=js"
import style0 from "./ThreatCanvasLayout.vue?vue&type=style&index=0&id=736b8c6d&prod&lang=scss&scoped=true"
import style1 from "./ThreatCanvasLayout.vue?vue&type=style&index=1&id=736b8c6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b8c6d",
  null
  
)

export default component.exports